import React, { Component } from 'react';
import styles from './Modules/AfterHours.module.css';

export default class EstimatedCostDetailsModal extends Component {
    constructor(props) {
        super(props);
        this.closePopUp = this.closePopUp.bind(this);
    }

    closePopUp(){  this.props.onCloseModal("close"); }

    render() {
        let {costDetails} = this.props;
        let requestsCount ="-";
        let totalHoursRequest ="-";
        let costPerHour ="-";
        let EstimatedCost ="-";
        let minimumCost = false;

          if(costDetails.hasOwnProperty('data')){
            requestsCount = costDetails.data.cost.noOfRequests;
            totalHoursRequest = costDetails.data.totalHours;
            costPerHour = costDetails.data.cost.currency+ costDetails.data.cost.amountPerHour;
            EstimatedCost = costDetails.data.cost.currency+ costDetails.data.cost.displayTotalAmount;
            minimumCost = costDetails.data.cost.minimumHoursApplied;
          }

        return (
            <div>
                <div  className={styles.modalHeader}> 
                    <h3 className={styles.subTitle}>Estimated Cost Details</h3>
                    <span className={styles.modalClose} onClick={this.closePopUp}>X</span>
                 </div>

                <div className={styles.modalContentContainer}>
                        <div className={styles.modalContent}>
                        <div className={styles.estimateBar}> <p className={styles.estimateLabel}>Number of Requests</p> <p className={styles.estimateValue}>{requestsCount} </p> </div>
                        <div className={styles.estimateBar} style={{backgroundColor:'#FAFAFA'}}> <p className={styles.estimateLabel}>Total Hours Requested</p> <p className={styles.estimateValue}>{totalHoursRequest.toFixed(2)} </p> </div>
                        <div className={styles.estimateBar} > <p className={styles.estimateLabel}>Cost per Hour</p> <p className={styles.estimateValue}>{costPerHour}</p> </div>
                        <div className={styles.estimateBar} style={{backgroundColor:'#FAFAFA'}}> <p className={styles.estimateLabel} style={{fontWeight:'bold'}}>Estimated Cost Hours Requested</p> <p className={styles.estimateValue} style={{fontWeight:'bold'}}>{EstimatedCost}</p> </div>
                        </div>
                        <p  className={styles.minimumCostText} style={{display: (minimumCost)?'initial' :'none'}} >*The minimum cost per request has been applied.</p>
                </div>
                
                <div  className={styles.modalFooter}>
                    <button className={styles.commentSaveButton} onClick={this.closePopUp}>CLOSE</button>
                </div>

            </div>
        );
    }
}